export const PICKER_MAX_WIDTH = 300;
export const PICKER_MIN_WIDTH = 180;
